














import { Pracovnik } from '@/modules/administrace/pracovnik';
import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';
import { types } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				pracovnik: `${this.storeUri}/${types.mutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
});
